module.exports = __webpack_public_path__ + "img/visitorManager.01faddc0.jpg";